'use strict';

/**
 * Burzum Like plugin js
 */
$.fn.like = function() {

	let identifier = this.data('identifier');
	let itemId = this.data('itemId');
	let isLiked = this.data('liked');
	let url = this.data('like-url');

	if (url === undefined) {
		url = '/ratings/like/';
	}

	if (isLiked) {

	} else {

	}

	$.post(url + identifier + '/' + itemId + '.json', {
		rating: isLiked
	});
};

(function($) {
	$.fn.bzLike = function(options) {
		let settings = $.extend({
			likedClass: 'liked',
			callback: function(data, textStatus, jqXHR) {
			}
		}, options);

		return this.each(function() {
			let element = $(this);
			let liked = element.data('liked');
			let id = element.data('like-id');
			let model = element.data('like-model');
			let attribute = element.data('like-attribute');

			let postData = {
				foreign_key: id,
				model: model,
				attribute: attribute,
				rating: 0
			};

			if (liked === 1 || liked === '1' || liked === true) {
				liked = true;
				postData.rating = 0;
			} else {
				postData.rating = 1;
			}

			if (liked === true) {
				element.addClass(settings.likedClass);
				postData.rating = 0;
			}

			element.on('click', function() {
				$.post('/ratings.json', postData, function(data, textStatus, jqXHR) {
					settings.callback(element, data, textStatus, jqXHR);
					if (data.rating.rating == 0) {
						element.removeClass(settings.likedClass);
						liked = true;
						postData.rating = 1;
					} else {
						element.addClass(settings.likedClass);
						liked = false;
						postData.rating = 0;
					}
				});
			});
		});
	};

}(jQuery));

$('.like-rating').bzLike({
	callback: function(element, data) {
		if (data.rating.rating == 1) {
			element.html('<i class="fa fa-star" aria-hidden="true"></i>');
		} else {
			element.html('<i class="fa fa-star-o" aria-hidden="true"></i>');
		}
	}
});
